import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {DcpLinkModel} from '@app/model/dcp-link-model';
import {NavigationComponentService} from '@app/services/navigation-component.service';
import {CmsComponentData} from '@spartacus/storefront';
import {CmsNavigationComponent} from '@spartacus/core';
import {map} from 'rxjs/operators';

@Component({
  selector: 'dcp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  componentData$: Observable<CmsNavigationComponent>;
  linksMap$: Observable<Map<string, Observable<DcpLinkModel>[]>>;

  /**
   * Names of the Nodes containing the links.
   */
  aboutLinksNode: string = 'AboutLinksNode';
  legalLinksNode: string = 'LegalLinksNode';
  socialMediaLinksNode: string = 'SocialMediaLinksNode';

  constructor(public navigationComponentService: NavigationComponentService,
              private cmsData: CmsComponentData<CmsNavigationComponent>) {
  }

  ngOnInit() {
    this.componentData$ = this.cmsData.data$;
    this.fetchComponentData();
  }

  fetchComponentData() {
    this.linksMap$ = this.componentData$.pipe(
      map((navComponent) => this.navigationComponentService.fetchNavNodeData(navComponent)));
  }
}
